module.exports = __webpack_public_path__ + "img/screenshot.2c9c7dea.png";